export default __webpack_public_path__ + "static/media/forgot-password-v2.92f01a1f.svg";